import { create } from "zustand";
import axios from "../helper/axios";

import useMembersStore from "./members.store";

const useClientStore = create((set, get) => ({
    isModalOpen: false,
    currentClientName: null,
    currentClientTAName:null,
    setCurrentClientName: (value) => {
        set({ currentClientName: value });
    },
    setCurrentClientTAName: (value) => {
        set({ currentClientTAName: value });
    },    
    setModalOpen: () => {
        set({ isModalOpen: true });
    },
    handleModalOk: () => {
        set({ isModalOpen: false });
    },
    handleModalCancel: () => {
        set({ isModalOpen: false });
    },
    handleClientAdd: async (value) => {
        console.log("Adding Client:",value);
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));

            await axios.post(`/addclients/${userData.qhoid}`, {
                    ...value,
            });
            useMembersStore.getState().getClients();
        } catch (err) {
            console.log(err);
        }
    },
    handleClientTAAdd: async (value) => {
        var t = get().currentClientName.clientName;
        console.log("Current Client:",t);
        console.log("Adding Client TA:",value);        
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            await axios.post(`/addtas/${userData.qhoid}/${t}`, {
                    ...value,
            });
            useMembersStore.getState().getClients();
        } catch (err) {
            console.log(err);
        }
    },    
    removeClient: async (clientName) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            await axios.delete(`/deleteclients/${userData.qhoid}/${clientName}`);

            useMembersStore.getState().getClients();
        } catch (err) {
            console.error(err);
        }
    },
    removeClientTA: async (clientName,taName) => {
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            await axios.delete(`/deletetas/${userData.qhoid}/${clientName}/${taName}`);

            useMembersStore.getState().getClients();
        } catch (err) {
            console.error(err);
        }
    },
    handleClientUpdate: async (body) => {
        try { 
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/updateclients/${userData.qhoid}/${userData.qhuid}`,
                body
            );
            console.log(response.data.name); 
            console.log(response.data.status);
            useMembersStore.getState().getClients();
        } catch (err) {
            console.error(err);
        }
    },  
    handleClientTAUpdate: async (clientName,body) => {
        try { 
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            const response = await axios.post(
                `/updatetas/${userData.qhoid}/${userData.qhuid}/${clientName}`,
                body
            );
            console.log(response.data.name); 
            console.log(response.data.status);
            useMembersStore.getState().getClients();
        } catch (err) {
            console.error(err);
        }
    },       
    handleAddBarredCompany: async (value) => {
        console.log(value);
        var t = get().currentClientName.clientName;
        console.log(t);
    
        try {
            const userData = JSON.parse(localStorage.getItem("userDetails"));
            await axios.post(`/addbarredcompanies/${userData.qhoid}/${t}`, {
                    ...value,
            });
            useMembersStore.getState().getClients();
        } catch (err) {
            console.log(err);
        }
    }  
}));

export default useClientStore;
